module.exports = "https://coursera_assets.s3.amazonaws.com/images/42219a1922763ae78928e5c60f9d9c4c.png";